module.exports = __webpack_public_path__ + "static/powerbi-merge-values-after-ec538126f932196b6043497b476b2783.png";